import React from 'react';
import PropTypes from 'prop-types';

import { TabContainer, TabInput, TabLabel } from './tabs.css';

class Tabs extends React.PureComponent {
	static propTypes = {
		name: PropTypes.string.isRequired,
		tabs: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.string.isRequired,
				label: PropTypes.string.isRequired,
				href: PropTypes.string
			})
		).isRequired,
		selectedTab: PropTypes.string,
		onTabSelected: PropTypes.func,
		marginBottom: PropTypes.number
	};

	handleTabClick = (e) => {
		let { onTabSelected } = this.props;

		onTabSelected && onTabSelected(e.target.value);
	};

	renderTab = (tab) => {
		let { name, selectedTab, onTabSelected } = this.props;

		const labelContent = tab.href
			? (
				<a
					href={tab.href}
					style={{ color: 'inherit', textDecoration: 'none' }}
					onClick={(e) => {
						if( e.ctrlKey || e.metaKey || e.button !== 0 ) {
							e.preventDefault();
							e.stopPropagation();
							window.open(tab.href, '_blank', 'noopener,noreferrer');
							return;
						}
						e.preventDefault();
						e.stopPropagation();
						onTabSelected && onTabSelected(tab.key);
					}}
				>
					{ tab.label }
				</a>
			)
			: tab.label;

		return (
			<React.Fragment key={tab.key}>
				<TabInput
					type="radio"
					id={`tab_${tab.key}`}
					name={name}
					value={tab.key}
					checked={selectedTab === tab.key}
					onChange={this.handleTabClick}
					data-testid={`tabs-${tab.key}-radio`}
				/>
				<TabLabel
					className="button"
					htmlFor={`tab_${tab.key}`}
					data-cy={`tabs-${name}-tab`}
					data-testid={`tabs-${tab.key}-tab`}
				>
					{ labelContent }
				</TabLabel>
			</React.Fragment>
		);
	};

	render() {
		let { name, tabs, marginBottom = 1 } = this.props;

		if( !tabs?.length ) {
			return null;
		}

		return (
			<TabContainer
				className="px-tabs button-group button-group-radio"
				marginBottom={marginBottom}
				data-cy={`tabs-${name}`}
				data-testid={`tabs-${name}`}
			>
				{ tabs.map(this.renderTab) }
			</TabContainer>
		);
	}
}

export default Tabs;
